import { createApi } from '@reduxjs/toolkit/query/react';

import { connectDocsApiBaseQuery } from './base-query';
import { endpointsFactory, reducerPath } from './endpoints';

const createDocsApi = () => {
  const connectv2DocsApi = createApi({
    baseQuery: connectDocsApiBaseQuery,
    reducerPath,
    endpoints: (_builder) => ({}),
  });

  /**
   * Upon import of react redux it creats a context. CreateApi depends on react redux and context cannot be used on the server.
   * Therefore we have to leverage the api directly on the server without rtqp and we must inject the endpoints separately.
   * https://github.com/reduxjs/react-redux/blob/89a86805f2fcf9e8fbd2d1dae345ec791de4a71f/src/components/Context.ts#L14
   * */
  const injectedApi = connectv2DocsApi.injectEndpoints({
    // We need to be able to pass the builder from our injection here as its bound to the base query..
    endpoints: (builder) => endpointsFactory(builder),
  });

  // Base Queries
  const getFlagsQuery = injectedApi.endpoints.getFlags;

  // Selectors
  const selectFlags = getFlagsQuery.select();

  // Actions
  const initiateGetFlags = getFlagsQuery.initiate();

  return {
    ...injectedApi,
    selectFlags,
    initiateGetFlags,
  };
};

let _connectv2DocsApi: ReturnType<typeof createDocsApi> | undefined;

/**
 * This is designed in this way as createApi is a side effect.
 * We should not have side effects importing a module. This
 * makes testing really hard as well as causes other complications
 * in bundling etc.
 */
const getConnectv2DocsApi = () => {
  if (_connectv2DocsApi) {
    return _connectv2DocsApi;
  }

  _connectv2DocsApi = createDocsApi();

  return _connectv2DocsApi;
};

export { getConnectv2DocsApi };
